import { render, staticRenderFns } from "./noticePopup.vue?vue&type=template&id=2b3e3f09&scoped=true"
import script from "./noticePopup.vue?vue&type=script&lang=js"
export * from "./noticePopup.vue?vue&type=script&lang=js"
import style0 from "./noticePopup.vue?vue&type=style&index=0&id=2b3e3f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e3f09",
  null
  
)

export default component.exports